import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgImage = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.6667 17.5589V18.1148C18.6667 19.0359 17.9205 19.7825 17 19.7825H3.66667C2.74618 19.7825 2 19.0359 2 18.1148V9.22039C2 8.29933 2.74618 7.55269 3.66667 7.55269H4.22222V14.7794C4.22222 16.312 5.46833 17.5589 7 17.5589H18.6667ZM22 14.7794V5.88499C22 4.96393 21.2538 4.21729 20.3333 4.21729H7C6.07951 4.21729 5.33333 4.96393 5.33333 5.88499V14.7794C5.33333 15.7005 6.07951 16.4471 7 16.4471H20.3333C21.2538 16.4471 22 15.7005 22 14.7794ZM10.8889 7.55269C10.8889 8.47375 10.1427 9.22039 9.22222 9.22039C8.30174 9.22039 7.55556 8.47375 7.55556 7.55269C7.55556 6.63163 8.30174 5.88499 9.22222 5.88499C10.1427 5.88499 10.8889 6.63163 10.8889 7.55269ZM7.55556 12.5558L9.48316 10.627C9.64587 10.4642 9.90969 10.4642 10.0724 10.627L11.4444 11.9999L16.1498 7.29159C16.3125 7.12878 16.5764 7.12878 16.7391 7.29159L19.7778 10.3322V14.2235H7.55556V12.5558Z", fill: props.fill }));
});
export default SvgImage;
